const firebaseConfig = {
    apiKey: "AIzaSyBSgt22oDriLJZc0SZosUn-siCrOP8LRXM ",
    authDomain: "partyloottracker-4358e.firebaseapp.com",
    projectId: "partyloottracker-4358e",
    storageBucket: "partyloottracker-4358e.appspot.com",
    messagingSenderId: "190188129669",
    appId: "1:190188129669:web:0b67ce6091239d955808ec"
}

export { firebaseConfig };